/**
 * Created by tofael on 11/21/17.
 */
import React from 'react';
import {Map} from 'immutable';
import {connect} from 'react-redux';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'material-ui/DatePicker';

import RaisedButton from 'material-ui/RaisedButton';
import {white} from 'material-ui/styles/colors';

import List from '../screens/list/';
import ActivityList from '../screens/shared/activity-list.component';

import api from '../utility/api';
import utils from '../utility/utils';
import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';
import { TextField } from 'material-ui';

class CallList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();

    let startDate = new Date();
    startDate.setDate(startDate.getDate()-14);

    this.state = {
      calls: Map(),
      limit:21,
      selectedCall: null,
      loadedPage:0,
      sortPref: defaultSort,
      pageSize,
      activityDialogOpen: false,
      activityList: [],
      callInfoSources: [],
      startDate,
      endDate: new Date(),
      operatorName: '',
      callerName: '',
      patientName: '',
      phone: ''
    };
  }

  componentDidMount() {
    this.getCallInfoSources();
  }

  dispatchAction(action){
    this.props.dispatch(action());
  }

  displayFeedBack(message){
    this.props.dispatch(showFeedback({message: message}));
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.CALL);
    let defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'date'
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  getCallRequests() {
    this.props.dispatch(asyncStart());
    const {startDate, endDate, operatorName, callerName, patientName, phone} = this.state;
    api.getOptimizedCallRequests(startDate, endDate, operatorName, callerName, patientName, phone)
      .then(resp => {
        this.props.dispatch(asyncEnd());
        let calls = Map();
        resp.forEach((call) => {
          calls = calls.set(call.id, call);
        });
        this.setState({calls});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  onPageChange(pageIndex) {
    let {loadedPage} = this.state;

    if(pageIndex > loadedPage) {
      //let newOffset = calls.length;
      ++loadedPage;
      this.setState({loadedPage});
      this.getCallRequests();
    }

  }

  getTdProps(state, rowInfo){
    return {
      onClick: e => {
        if (rowInfo)
          this.getActivities(rowInfo.row._original);
      }
    }
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.CALL);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.CALL, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.CALL);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.CALL, currentPreference);
  }

  getActivities(call){
      api.getCallActivity(call.id)
        .then((activityList)=>{
          this.setState({activityList, activityDialogOpen:true, selectedCall: call})
        })
  }

  getCallInfoSources(){
    api.getCallInfoSourceList()
      .then((callInfSourceList)=>{
        callInfSourceList.push({source: 'All'});
        this.setState({callInfoSources:callInfSourceList})
      })
  }

  onActivityDialogClose(){
    this.setState({selectedCall: null, activityList:[], activityDialogOpen: false})
  }

  toggleTestCallFlag(){
    this.dispatchAction(asyncStart);
    let call = this.state.selectedCall;
    let {id: requestId} = call;
    api.toggleTestCallFlag(requestId)
      .then(responseData => {
        let updatedCall = this.state.calls.get(requestId);
        updatedCall.test = responseData.test;
        this.setState({
          calls: this.state.calls.set(requestId, updatedCall)
        });
        this.onActivityDialogClose();
        this.displayFeedBack(`Call marked as test`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  }

  onDateChange(dateType, _, date) {
    this.setState({[dateType]: date});
  }

  onHandleChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  render() {
    let callInfoSources = this.state.callInfoSources;

    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false
      },
      {
        id: 'date',
        Header: 'Date',
        accessor: d =>  new Date(d.created_at),
        Cell: props => <span>{utils.toAppDate(props.value)}</span>,
        maxWidth:180,
        filterMethod: (filter, row) => {
          return filter === null || filter.value === null ||utils.isSameDay(filter.value, row[filter.id])
        },
        Filter: ({ filter, onChange }) =>
          <DatePicker
            cancelLabel='Clear'
            textFieldStyle={{height: '100%', position: 'inherit'}}
            value={filter ? filter.value : null}
            onDismiss={()=> onChange(null)}
            onChange={(event, date) => onChange(date)}
            />
      },
      {
        Header: 'Phone',
        accessor: 'phone',
        maxWidth:180,
      },
      {
        id:'by',
        Header: 'By',
        accessor: d => d.source,
        maxWidth:100,
      },
      {
        Header: 'Caller Name',
        accessor: 'name',
        Cell: props => <div style={{whiteSpace:'normal'}}>{props.value}</div>,
        maxWidth: 150
      },
      {
        id:'source',
        Header: 'Info source',
        maxWidth:120,
        accessor: d => d.info_source ? d.info_source : d.consumer && d.consumer.info_source ? `${d.consumer.info_source}(OLD)` :'',
        filterMethod: (filter, row) => {
          return filter.value === 'All' || filter.value === row[filter.id]
        },
        Filter: ({ filter, onChange }) =>
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "All"}>
            {
              callInfoSources && callInfoSources.map((item, key)=>
                <option value={item.source} key={key}>{item.source}</option>
              )
            }
          </select>
      },
      {
        id: 'operator',
        Header: 'Operator',
        accessor: d => d.operator ? d.operator.name : ''
      },
      {
        Header: 'State',
        accessor: 'state',
        maxWidth:100,
      },
      {
        Header: 'Call Resolution',
        accessor: 'result',
        maxWidth:150,
      },
      {
        Header: 'Comment',
        accessor: 'comment',
        Cell: props => <div style={{whiteSpace:'normal'}}>{props.value}</div>,
        minWidth: 200
      }
    ];

    let {calls, sortPref, activityList, activityDialogOpen, selectedCall, 
      startDate, endDate, operatorName, phone, callerName, patientName} = this.state;
    let {isLoading} = this.props.application;
    let reactTableProps = {
      data: calls.toArray(),
      columns,
      isLoading,
      defaultSorted: sortPref,
      noDataText: 'No calls found',
      onSortedChange: this.onSortedChange.bind(this),
      getTdProps: this.getTdProps.bind(this)
    };

    const actions = [
      <RaisedButton
        labelColor={white}
        label={selectedCall && selectedCall.test ? 'Unmark Test' : 'Mark As Test call'}
        style={{marginRight:'10px'}}
        backgroundColor='#D02504'
        onClick={this.toggleTestCallFlag.bind(this)} />
    ];
    return (
      <div>
        <div className="row">
          <div className="column">
           <DatePicker
           floatingLabelText="From"
           value={startDate}
           firstDayOfWeek={0}
           onChange={this.onDateChange.bind(this, 'startDate')} 
          /> 
          </div>
          <div className="column">
           <DatePicker
           floatingLabelText="To"
           value={endDate}
           firstDayOfWeek={0}
           onChange={this.onDateChange.bind(this, 'endDate')} 
          /> 
          </div>
          <div className="column">
            <TextField
            floatingLabelText="Operator's Name"
            value={operatorName}
            onChange={this.onHandleChange.bind(this, 'operatorName')}
            />
          </div>
          <div className="column">
            <TextField
            floatingLabelText="Caller's Name"
            value={callerName}
            onChange={this.onHandleChange.bind(this, 'callerName')}
            />
          </div>
          <div className="column">
            <TextField
            floatingLabelText="Patient's Name"
            value={patientName}
            onChange={this.onHandleChange.bind(this, 'patientName')}
            />
          </div>
          <div className="column">
            <TextField
            floatingLabelText="Caller's Phone"
            value={phone}
            onChange={this.onHandleChange.bind(this, 'phone')}
            />
          </div>
          </div>
        <RaisedButton
            label="Get Calls"
            disabled={!startDate || !endDate}
            primary={true}
            onClick={this.getCallRequests.bind(this)}
          />
        <List
          title="Calls"
          reactTableProps={reactTableProps}
        />
        <Dialog
          modal={false}
          open={activityDialogOpen}
          autoScrollBodyContent={true}
          actions={actions}
          onRequestClose={this.onActivityDialogClose.bind(this)}>

          <ActivityList
            activityList={activityList}
          />
        </Dialog>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(CallList);


// WEBPACK FOOTER //
// ./src/containers/calls.js